import { render, staticRenderFns } from "./THFdetail.vue?vue&type=template&id=28263282&scoped=true"
import script from "./THFdetail.vue?vue&type=script&lang=js"
export * from "./THFdetail.vue?vue&type=script&lang=js"
import style0 from "./THFdetail.vue?vue&type=style&index=0&id=28263282&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28263282",
  null
  
)

export default component.exports